<template>
  <div class="PublicityDetail9">
    <h3>防范非法金融活动宣传月活动丨守住钱袋子·护好幸福家</h3>
    <img :src="require('../images/ic_publicity_detail9_1.jpg')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail9_2.jpg')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail9_3.png')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail9_4.png')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail9_5.png')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail9_6.png')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail9_7.png')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail9_8.png')"/>
    <br/>
    <img :src="require('../images/ic_publicity_detail9_9.png')"/>
  </div>
</template>

<script>
export default {
  name: 'PublicityDetail9'
};
</script>

<style scoped lang="less">
.PublicityDetail9 {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 52px;
    align-self: center;
  }

  div {
    text-align: left;
  }

  img {
    width: 100%;
    margin-top: 30px;
    align-self: center;
  }
}
</style>
